<template>
  <div class="form-group">
    <label :style="'color:'+template.style.surveyTextColor" class="title-bold" for="nome">{{ questionText }}</label>
    <vs-row vs-justify="flex-start"
            vs-type="flex"
            v-for="(ans, index) in l"
            v-bind:key="index"
            class="mb-3">
      <textarea
          class="form-control"
          rows="1"
          :placeholder="getPlaceHolder"
          :style="template.style.surveyBgColor ? {backgroundColor: template.style.surveyBgColor, color: template.style.surveyTextColor} : {color: template.style.surveyTextColor}"
          v-model="l[index]"
          :disabled="processingApi"
          v-on:keyup.enter="enterKey(index)"
          v-on:keyup="allKeys"
      >

      </textarea>
    </vs-row>
  </div>
</template>

<script>
export default {
  name: "Survey-Multiple-Text",
  props: {
    questionText: {type: String},
    questionId: {type: Number},
    placeHolder: {type: String},
    config: {type: String}
  },
  data: () => ({
    qtAnwser: "",
    dataOk: false,
    nMax: 1,
    l: [],
    processingApi: false,
  }),
  computed: {
    getPlaceHolder() {
      if (this.placeHolder) return this.placeHolder;
      else return this.$t('type_answer_here');
    },
    template() {
      return this.$store.state.template;
    }
  },
  created() {
    let i;
    if (this.config.includes("n:")) {
      const opts = this.config.split(";");
      for (i = 0; i < opts.length; i++) {
        if (opts[i].includes("n:")) {
          const r = opts[i].split(":");
          this.nMax = r[1];
        }
      }
    }

    for (var j = 0; j < this.nMax; j++) this.l.push("");

    this.qtAnwser = this.$store.getters.answerValue(this.questionId);

    if (this.$store.getters.answerValue(this.questionId)) {
      const answer = this.$store.getters.answerValue(this.questionId);
      this.answerList = [];
      const s = answer.split(";");
      for (i = 0; i < s.length - 1; i++)
        this.l[i] = s[i];
    }
  },
  updated() {
    this.focusInput();
  },
  methods: {
    mountAnswer: function () {
      let resp = "";
      for (let i = 0; i < this.l.length; i++) {
        if (this.l[i] !== "")
          resp = resp + this.l[i] + ";";
      }
      return resp;
    },

    focusInput() {
      this.$refs.fc.$el.focus();
    },
    allKeys() {
      const resp = this.mountAnswer();
      this.$emit("AnswerChanged", resp, this.questionId)
    },
    enterKey(index) {
      if (index === this.l.length - 1) {
        const resp = this.mountAnswer();
        this.processingApi = true
        this.$emit("QuestionAnwered", resp, this.questionId).then(() => this.processingApi = false)
      } else {
        let inputsRef = document.getElementsByTagName('input')
        inputsRef[index + 1].focus()
      }
    }
  },
  directives: {
    focus: {
      // directive definition
      inserted: function (el) {
        el.focus();
      }
    }
  },
};
</script>


<style scoped>
.title-bold {
  font-family: 'OxaniumBold';
}
</style>
